import React, { FunctionComponent } from "react"
import "./styles.scss"
import { useParams, NavLink } from "react-router-dom"

const subRoutes = [
  "contacts",
  "critical-functions",
  "key-resources",
  "information-technology",
  "faculty-preparedness",
  "instruction"
]

interface Props {
  showFacultyLink?: boolean
  currentRailsPath: string
}

const MainNavigation: FunctionComponent<Props> = ({
  showFacultyLink = false,
  currentRailsPath
}) => {
  // determine if navigation route paths need to be prefixed in "edit" mode
  const getDomainSuffix = (route) => {
    if (route && route.endsWith("/edit")) {
      return "/edit"
    } else {
      return ""
    }
  }
  const suffixPath = getDomainSuffix(currentRailsPath)

  const { appPrefix, planName, planCategory } = useParams()
  let isInKnownSubroute = true

  // if current route is not part of defined subroute consider it in a generic subroute
  if (planCategory) {
    isInKnownSubroute = subRoutes.some((route) => route === planCategory)
  }

  let domainPrefix = ""
  if (appPrefix) {
    domainPrefix = "/" + appPrefix
  }

  // if we have navigated via back button or pushState force reload as React router navigates via `pushState`,
  // will be removed when app is full React
  // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
  const detectBackButtonPush = () => {
    window.onpopstate = function(event) {
      window.location.reload()
    }
  }
  detectBackButtonPush()

  return (
    <React.Fragment>
      <div className="plan-navigation">
        <ul>
          <li>
            <NavLink
              exact
              to={`${domainPrefix}/plans/${planName}${suffixPath}`}
              activeClassName="active"
              isActive={(match, location) => {
                // any route not part of known subroute is considered active under plan details
                if (!isInKnownSubroute || !planCategory) {
                  return true
                }
              }}
            >
              Plan Details
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`${domainPrefix}/plans/${planName}/contacts/key-people${suffixPath}`}
              activeClassName="active"
              isActive={(match, location) => {
                if (planCategory === "contacts") {
                  return true
                }
              }}
            >
              Contacts
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`${domainPrefix}/plans/${planName}/critical-functions${suffixPath}`}
              activeClassName="active"
              isActive={(match, location) => {
                if (planCategory === "critical-functions") {
                  return true
                }
              }}
            >
              Critical Functions
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`${domainPrefix}/plans/${planName}/key-resources/staff-basics${suffixPath}`}
              activeClassName="active"
              isActive={(match, location) => {
                if (planCategory === "key-resources") {
                  return true
                }
              }}
            >
              Key Resources
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`${domainPrefix}/plans/${planName}/information-technology/central-applications${suffixPath}`}
              activeClassName="active"
              isActive={(match, location) => {
                if (planCategory === "information-technology") {
                  return true
                }
              }}
            >
              Information Technology
            </NavLink>
          </li>
          {showFacultyLink && (
            <li>
              <NavLink
                to={`${domainPrefix}/plans/${planName}/faculty-preparedness/action-items${suffixPath}`}
                activeClassName="active"
                isActive={(match, location) => {
                  if (planCategory === "faculty-preparedness") {
                    return true
                  }
                }}
              >
                Faculty Preparedness
              </NavLink>
            </li>
          )}
          {!showFacultyLink && (
            <li>
              <NavLink
                to={`${domainPrefix}/plans/${planName}/instruction${suffixPath}`}
                activeClassName="active"
                isActive={(match, location) => {
                  if (planCategory === "instruction") {
                    return true
                  }
                }}
              >
                Instruction
              </NavLink>
            </li>
          )}
        </ul>
      </div>
    </React.Fragment>
  )
}

export default MainNavigation
